import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import perioImg from '../media/perio.jpg'
import perio2Img from '../media/perio2.png'
import {useTranslation, Trans} from 'react-i18next'

export default function Perio() {

    const { t } = useTranslation();
    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {perioImg}
            title = {t('treatSectionPerio')}
            paragraph = {t('perioSubtitle')}
            mediaContent = 
            {
            `# ${t('treatSectionPerio')}
***  

${t('perioParaf')}
![](${perio2Img})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
